export const isEventTargetSpecificTag = (event, tagName) =>
  event.target.tagName.toUpperCase() === tagName.toUpperCase();

export const scrollIntoViewWithOffset = (ref, offset) => {
  window.scrollTo({
    behavior: "smooth",
    top: ref?.current.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset
  });
};
